module.exports = "/assets/data/84f43a4f50775fdbf2952c433db08e3e-CF71.data.json";